import SearchResultsApp from '@/apps/SearchResultsApp.vue'
import { createApp } from 'vue'

export default function () {
  const containerEl = document.querySelector('[data-predictive-search-root]')
  if (containerEl) {
    const app = createApp(SearchResultsApp)
    app.mount(containerEl)
  }
}
